export default __webpack_public_path__ + "cf0dc0c4d45aa724a385e170ed420b37.png";